import React from 'react'

import TipsheetCard from '../TipsheetCard'

import * as s from './TipsheetsList.module.css'

function TipsheetsList({ tipsheets }) {
  return (
    <section className={s.root}>
      {tipsheets
        .sort(({ featured }) => featured ? 1 : -1)
        .map(
          ({ id, ...tipsheet }) => (
            <div key={`tipsheets-list-${id}`}>
              <TipsheetCard {...tipsheet} />
            </div>
          )
        )}
    </section>
  )
}

export default TipsheetsList
